/*!

=========================================================
* Argon Dashboard PRO React - v1.2.5
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// react library for routing
import {
  useLocation,
  Route,
  Routes,
  Navigate,
  useNavigate,
} from "react-router-dom";

// core components
import AuthNavbar from "components/Navbars/AuthNavbar.js";
import AuthFooter from "components/Footers/AuthFooter.js";

import routes from "routes/routes.js";
import { useAuth } from "context/AuthContext";
import { ROLES } from "variables/constants";

function Auth() {
  const { role, isAuthenticated, loading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const mainContentRef = React.useRef(null);

  // React.useEffect(() => {
  //   if (isAuthenticated) {
  //     if (role === ROLES.superAdmin || role === ROLES.admin) {
  //       navigate("/admin/dashboard");
  //     } else if (role === ROLES.publisher) {
  //       navigate("/publisher/dashboard");
  //     }
  //   } else {
  //     navigate("/auth/login");
  //   }
  // }, [isAuthenticated, role]);

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContentRef.current.scrollTop = 0;
    document.body.classList.add("bg-default");
    // Specify how to clean up after this effect:
    return function cleanup() {
      document.body.classList.remove("bg-default");
    };
  });
  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContentRef.current.scrollTop = 0;
  }, [location]);
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.layout === "/auth") {
        return (
          <Route path={prop.path} element={prop.component} key={key} exact />
        );
      } else {
        return null;
      }
    });
  };

  return (
    <>
      <div className="main-content" ref={mainContentRef}>
        {/* <AuthNavbar /> */}
        <Routes>
          {getRoutes(routes)}
          <Route
            path="*"
            element={
              isAuthenticated ? (
                role === ROLES.superAdmin || role === ROLES.admin ? (
                  <Navigate to={"/admin/dashboard"} />
                ) : (
                  <Navigate to={"/admin/tables"} />
                )
              ) : (
                <Navigate to={"/auth/login"} />
              )
            }
          />
        </Routes>
      </div>
      {/* <AuthFooter /> */}
    </>
  );
}

export default Auth;
